module.exports = __webpack_public_path__ + "static/media/reina_vic.5f484ab9.png";